/**
 * Created by Nemanja on 9/28/18.
 */

import React from 'react';
import TitleDescriptionBox from '../common/TitleDescriptionBox';
import { withStyles, Button, Typography, TextField } from '@material-ui/core';

const styles = theme => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    innerContainer: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        width: '100%'
    },
    innerContainer2: {
        flexDirection: 'column',
        display: 'flex',
        alignItems: 'center',
        flex: 1,
        padding: 25,
    },
    addButton: {
        marginTop: 10,
        width: 220,
        height: 20
    }
});

class ProjectUseCases extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            useCases: {},
            selectedUseCaseId: null,
            name: '',
            description: ''
        }
    }

    componentDidMount() {
        if (this.props.useCases) {
            this.setState({
                useCases: this.props.useCases
            })
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.useCases !== this.props.useCases) {
            this.setState({ useCases: this.props.useCases })
        }
    }

    handleTextFieldChange = (propertyName, index, field, value) => {
        this.setState((state) => {
            const property = state[propertyName];
            property[index][field] = value;
            return { ...state, property };
        });
    };

    handleNameChange = (e) => this.setState({ name: e.target.value });

    handleDescriptionChange = (e) => this.setState({ description: e.target.value });

    handleSelectUseCase = (useCaseId) => {
        this.setState(state => ({
            selectedUseCaseId: useCaseId,
            name: state.useCases[useCaseId].name,
            description: state.useCases[useCaseId].description,
        }));
    };

    handleSaveUseCase = () => {
        const { name, description, selectedUseCaseId } = this.state;
        const { onSaveUseCase } = this.props;
        onSaveUseCase(selectedUseCaseId, name, description);
        this.setState({ name: '', description: '', selectedUseCaseId: null });
    };

    render() {

        const { classes, onAddUseCase, onDeleteUseCase, onUseCaseNameBlur, onUseCaseDescriptionBlur } = this.props;

        const { useCases, name, description } = this.state;

        const useCasesForRender = Object.keys(useCases || {}).map((useCaseId) => {
            const { name, description } = useCases[useCaseId];
            return <TitleDescriptionBox
                key={useCaseId}
                name={name}
                description={description}
                onNameChange={(e) => this.handleTextFieldChange('useCases', useCaseId, 'name', e.target.value)}
                onDescriptionChange={(e) => this.handleTextFieldChange('useCases', useCaseId, 'description', e.target.value)}
                onDeleteClick={() => onDeleteUseCase(useCaseId)}
                onNameBlur={(e) => onUseCaseNameBlur(useCaseId, e.target.value)}
                onDescriptionBlur={(e) => onUseCaseDescriptionBlur(useCaseId, e.target.value)}
            />
        });

        return (
            <div className={classes.container}>
                <div className={classes.innerContainer}>
                    <div className={classes.innerContainer2}>
                        <div style={{ width: 400, textAlign: 'left' }}>
                            <Typography variant="title">Use Case hinzufügen</Typography>
                        </div>
                        <TextField
                            style={{ width: 400 }}
                            label="Name"
                            margin="normal"
                            value={name}
                            onChange={this.handleNameChange}
                        />
                        <TextField
                            style={{ width: 400 }}
                            label="Beschreibung"
                            multiline
                            rows="4"
                            margin="normal"
                            value={description}
                            onChange={this.handleDescriptionChange}
                        />
                        <div style={{ width: 400, textAlign: 'right' }}>
                            <Button
                                className={classes.addButton}
                                color="primary"
                                variant="contained"
                                aria-label="Add Target Group"
                                onClick={this.handleSaveUseCase}
                            >
                                Use Case hinzufügen
            </Button>
                        </div>
                    </div>
                    <div className={classes.innerContainer2}>
                        {useCasesForRender}
                    </div>
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(ProjectUseCases);



// WEBPACK FOOTER //
// ./src/components/ProjectSetup/ProjectUseCases.js